import { FlexColMd } from 'components/Elements';
import styled from 'styled-components';
import { sizes, breakpoints, theme } from 'theme';

export const SaveButtonAndNotificationContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: ${sizes.spacingMd};
    min-height: 72px;
    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column-reverse;
    }
`;

export const RightNavButtonContainer = styled.div`
    display: grid;
    justify-items: flex-end;
    width: 100%;
`;

export const LeftNavButtonContainer = styled.div`
    display: grid;
    justify-items: flex-start;
`;

export const ResourcesContainer = styled(FlexColMd)`
    background-color: ${theme.cardSecondaryBackgroundColour};
    padding: ${sizes.spacingMd};
`;

export const courseBuilderBreakpoint = 700;
